import Page from "@/components/pages/inventory/category/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/inventory/category/")({
	component: Page,
});
